let prefix = '/api/sap/business-partners';

function search(cardCode) {
    return window.axios.get(prefix+'/search/'+cardCode)
}
function showByCardType(cardType) {
    return window.axios.get(prefix+'/show/'+cardType)
}
function customers() {
    return window.axios.get(prefix+'/customers')
}
function customersChange(data) {
    return window.axios.get(prefix+'/customers',data)
}

function customersOneChange(data) {
    return window.axios.post(prefix+'/customers',data)
}
function getAllBuissnesPartners(){
    return window.axios.post(prefix + '/index')
}

export default {
    search,showByCardType,customers,customersChange,customersOneChange, getAllBuissnesPartners
}